const AUTH_SESSION_SNAPSHOT_KEY = 'crm_auth_session_snapshot';

export interface AuthSessionSnapshotInterface {
    savedAtMs: number;
    data: Record<string, unknown>;
}

export function saveAuthSessionSnapshot(userData: Record<string, unknown>): void {
    const userId = userData?.id;
    if (userId == null || userId === '') {
        return;
    }

    const snapshot: AuthSessionSnapshotInterface = {
        savedAtMs: Date.now(),
        data: userData,
    };
    sessionStorage.setItem(AUTH_SESSION_SNAPSHOT_KEY, JSON.stringify(snapshot));
}

export function loadAuthSessionSnapshot(): AuthSessionSnapshotInterface | null {
    try {
        const rawSnapshot = sessionStorage.getItem(AUTH_SESSION_SNAPSHOT_KEY);
        if (!rawSnapshot) {
            return null;
        }

        const parsedSnapshot = JSON.parse(rawSnapshot) as AuthSessionSnapshotInterface;
        if (parsedSnapshot?.data?.id == null || parsedSnapshot.data.id === '') {
            return null;
        }

        return parsedSnapshot;
    } catch {
        return null;
    }
}

export function clearAuthSessionSnapshot(): void {
    sessionStorage.removeItem(AUTH_SESSION_SNAPSHOT_KEY);
}

export function clearAuthTokensFromStorage(): void {
    localStorage.removeItem('api_token');
    localStorage.removeItem('token');
    clearAuthSessionSnapshot();
}
